import css from 'styled-jsx/css';

export default css`
  .banner-reloj-TeCuida {
    background-color: var(--color-gp--grey1);
    :global(picture.imgBanner.imgDesktop) {
      width: 50% !important;
      display: flex;
      justify-content: flex-end;
      :global(img.imgBanner.imgDesktop) {
        width: auto;
        padding: 2rem;
      }
    }
  }
  .moduloBanner {
    background-size: cover !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 470px;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
    max-width: 1920px;
    margin: auto;

    :global(picture.imgBanner) {
      position: absolute;
      top: 0px;
      height: inherit;
      width: 100%;
      :global(img.imgMobile) {
        margin: 0 auto;
      }
    }
    :global(picture.imgBanner .imgDesktop) {
      height: 430px;
    }
    :global(picture.imgBanner.imgMobile) {
      display: none;
    }
    .container {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 20px;
    }

    .display-end {
      justify-content: end;
    }

    .text-center {
      text-align: center;
    }

    .cta {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      align-items: flex-start;
      padding: 1.5rem;
      background-color: var(--color-gp--white);
      max-width: 497px;
      text-align: left;
      border-radius: 8px;

      :global(.counter > div) {
        display: flex;
        height: 50px;
        margin-top: 20px;
      }
      :global(.ctaNombreComercial, .ctaTextUnderPrice) {
        font-size: 14px;
      }
      :global(.nombre) {
        font-size: 32px;
      }

      :global(.bandaPromo) {
        background-color: var(--color-movistar--red70);
        padding: 1px 8px;
      }

      :global(.bandaInfo) {
        background-color: #f6ecf6;
        padding: 4px 12px;
        border-radius: 50px;
        display: inline-block;
      }

      .ctaButton {
        width: 100%;
        display: flex;
        justify-content: flex-start;
      }

      :global(.ctaButton > button, .ctaButton > a) {
        width: 100%;
      }

      .withBorder {
        padding-bottom: 1rem;
        border-bottom: solid 1px var(--color-gp--grey3);
      }

      .prices {
        display: flex;
        gap: 10px;
        align-items: baseline;
        justify-content: center;
        flex-wrap: wrap;
      }

      .pvpTachado {
        font-size: 2rem;
        color: #999;
        margin-right: 0.3rem;
        text-decoration: line-through;
        font-family: 'Bold';
      }
      .price {
        color: #2a2a3c;
        font-family: 'Bold';
        font-size: 1.75rem;
      }
      .contractDetails {
        position: relative;
      }
    }
    &_legals {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.3rem;
    }
  }
  @media screen and (max-width: 768px) {
    .moduloBanner {
      height: 550px;
      justify-content: end;
      :global(picture.imgBanner.imgDesktop) {
        display: none;
      }
      :global(picture.imgBanner.imgMobile) {
        display: block;
      }
      .cta {
        :global(.nombre) {
          font-size: 28px;
        }
        :global(.ctaButton > button) {
          width: 100%;
        }
      }
      .display-end {
        justify-content: center;
      }

      .container {
        flex-direction: column;
        gap: 50px;
      }
    }
  }
`;
